import React, { useEffect, useState } from "react";

import NavBar from "./NavBar";
import { auth } from "../firebase";

import Goal from "./Goal";
import Cookies from "js-cookie";
import SelectGoalType from "./SelectGoalType";
import { getCurrentGoals, goalDidToday, shuffleArray } from "../util";
import { AddGoal } from "./AddGoal";
import eventBus from "../eventBus";

const Home = () => {
  const [goals, setGoals] = useState([]);
  const [user, setUser] = useState();
  const [displayGoals, setDisplayGoals] = useState();

  const [search, setSearch] = useState("");
  const [searchGoalType, setSearchGoalType] = useState([]);
  const [showDone, setShowDone] = useState(true);
  const [icon, setIcon] = useState("🔀"); // Default icon
  const icons = ["🔀", "🔄", "♻️", "🎲"]; // Example set of icons

  const randomizeGoals = () => {
    const shuffledGoals = shuffleArray([...displayGoals]);
    setDisplayGoals(shuffledGoals);

    const filteredIcons = icons.filter((i) => i !== icon);

    const randomIcon =
      filteredIcons[Math.floor(Math.random() * filteredIcons.length)];
    setIcon(randomIcon);
  };

  useEffect(() => {
    setInterval(() => {
      if (!user) setUser(auth.currentUser);
    }, 1000);
  }, []);

  useEffect(() => {
    getCurrentGoals(user, setGoals);
  }, [setGoals, user, showDone]);

  eventBus.register('refreshGoals', () => {
    getCurrentGoals(user, setGoals);
  })

  const updateGoals = () => {
    let updatedGoals = goals;

    if (search.length > 0) {
      updatedGoals = updatedGoals.filter((goal) =>
        goal.goal.toLocaleLowerCase().includes(search.toLocaleLowerCase()),
      );
    }

    if (searchGoalType?.length > 0) {
      updatedGoals = updatedGoals.filter((goal) =>
        goal.type?.toLowerCase().includes(searchGoalType.toLowerCase()),
      );
    }
    if (!showDone) {
      updatedGoals = updatedGoals.filter((goal) => goalDidToday(goal.days));
    }

    setDisplayGoals(updatedGoals);
  };

  useEffect(updateGoals, [search, goals, searchGoalType, showDone]);

  return (
    <div className="container mx-auto px-4 mb-[200px]">
      <NavBar />
      <AddGoal goals={goals} />
      <div className="my-4"></div>
      <div className="relative mb-4">
        <label
          htmlFor="name"
          className="absolute -top-2 left-2 inline-block bg-white px-1 text-xs font-medium text-gray-900"
        >
          Search
        </label>
        <input
          type="text"
          name="name"
          id="name"
          className="block w-[100%] rounded-md py-1.5 text-gray-900 shadow-sm placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 pl-4 border border-gray-300"
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>
      <SelectGoalType setSearchGoalType={setSearchGoalType} />

      <div className="flex justify-between">
        <div className="flex items-center gap-2 my-4">
          <label
            htmlFor="showDone"
            className="text-sm font-medium text-gray-900"
          >
            Show Done?
          </label>
          <input
            type="checkbox"
            id="showDone"
            checked={showDone}
            onChange={(e) => setShowDone(e.target.checked)}
            className="w-4 h-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
          />
        </div>
        <div className="my-4">
          <button
            onClick={randomizeGoals}
            className="px-2 py-1 rounded-md bg-indigo-600 text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
          >
            {icon} Randomize Goals
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-1 gap-4">
        {displayGoals?.map((goal) => (
          <div key={goal.id} className="p-4 shadow-lg rounded-lg bg-white">
            <Goal goal={goal} />
          </div>
        ))}
        {displayGoals?.length == 0 && <p>Add your daily/weekly habits below!</p>}
      </div>
    </div>
  );
};

export default Home;
